import { supabase } from "@utils/supabase";

export interface QROrLinkGeneratorFormType {
    whatsappNumber: string;
    message: string;
}

export const insertQRGeneratorDataInDB = async (formData: QROrLinkGeneratorFormType): Promise<void> => {
    try {
        supabase && (await supabase.from("free_tool_qr_generator").insert(formData));
    } catch (err) {
        console.error(err);
    }
};

export const insertLinkGeneratorDataInDB = async (formData: QROrLinkGeneratorFormType): Promise<void> => {
    try {
        supabase && (await supabase.from("free_tool_link_generator").insert(formData));
    } catch (err) {
        console.error(err);
    }
};

export interface WidgetFormType {
    wanumber: string;
    brandName: string;
    statusTag: string;
    logo: string;
    welcomeText: string;
    triggerMsg: string;
    widgetStyle: string;
    widgetPosition: string;
    widgetPositionMarginX: number;
    widgetPositionMarginY: number;
    customQuestion?: string;
    startChatBtnTxt?: string;
    question?: string;
    replyOptions?: string[];
    mailId?: string;
}

interface AiChatbotFormData {
    name: string;
    businessEmail: string;
}

export const insertWidgetDataInDB = async (formData: WidgetFormType): Promise<void> => {
    try {
        supabase && (await supabase.from("free_tool_chat_button").insert(formData));
    } catch (err) {
        console.error(err);
    }
};

export const insertAiChatbotDataInDB = async (formData: AiChatbotFormData): Promise<void> => {
    try {
        if (!formData) return;
        supabase && (await supabase.from("whatsapp-ai-chatbot-form").insert(formData));
    } catch (err) {
        console.error(err);
    }
};

export const updateMailIdInWidgetData = async (data: Pick<WidgetFormType, "wanumber" | "mailId">): Promise<void> => {
    try {
        supabase && (await supabase.from("free_tool_chat_button").update({ mailId: data.mailId }).eq("wanumber", data.wanumber));
    } catch (err) {
        console.error(err);
    }
};

export interface TemplateGeneratorFormType {
    businessName: string;
    businessBio: string;
    messageText: string;
    messageTone: string;
    addEmoji?: boolean;
    mode?: string;
}

export const insertAITemplateGeneratorDataInDB = async (formData: TemplateGeneratorFormType): Promise<void> => {
    try {
        supabase && (await supabase.from("free_tool_ai_template_generator").insert(formData));
    } catch (err) {
        console.error(err);
    }
};
